import { Injectable } from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PrintService {
  onPrintOpen = new Subject<{component: any, data: any, onClose: () => void}>();
  onPrintStart = new Subject<string>();
  onPrintStop = new Subject<void>();

  constructor() { }

  open({component, data, onClose}) {
    this.onPrintOpen.next({component, data, onClose})
  }

  start(name?: string) {
    this.onPrintStart.next(name);
  }

  stop() {
    this.onPrintStop.next();
  }
}
